import RichText from '../RichText/RichText';

import type { RichTextTablesProps } from '@skyscanner-internal/landing-pages-shared-types/src/types-shared/RichTextTablesProps';

const RichTextTables = (props: RichTextTablesProps) => (
  <RichText {...props.richTextProps} />
);

export default RichTextTables;
